const _base = {
  aboutRole: (title) => `
<div class="job-about">
  <p><strong>Location:</strong> Remote</p>
  <p><strong>Duration:</strong> 3 or 6 months</p>
  <p><strong>Type:</strong> Full-Time (8 hrs/day) or Part-Time (4 hrs/day)</p>

  <h4>Stipend &amp; Benefits</h4>
  <p>Full-Time: ₹3,000 to ₹5,000/month + PPO<br/>Part-Time: Bonus-based compensation + Certificate + PPO</p>

  <h4>Part-time Intern Perks</h4>
  <ul>
    <li>Certificate of completion</li>
    <li>Work from home</li>
    <li>Flexible hours</li>
    <li>5 days a week</li>
    <li>Letter of recommendation</li>
    <li>PPO opportunity (Pre-Placement Offer)</li>
  </ul>

  <h4>About Avijo</h4>
  <p>At Avijo, we are revolutionizing healthcare by building a technology-driven ecosystem that enhances accessibility, affordability, and efficiency. As we grow, we seek a passionate ${title} to help design intuitive and engaging experiences for our users.</p>
</div>
`,

  keyResponsibilities: () => `
<div class="job-responsibilities">
  <h4>Role &amp; Responsibilities</h4>
  <ul>
    <li>Assist in designing and refining user interfaces for web and mobile applications</li>
<li>Conduct user research, usability testing, and gather feedback to improve designs</li>
<li>Create wireframes, prototypes, and design mockups using Figma or Adobe XD</li>
<li>Collaborate with developers, product managers, and the founding team to bring ideas to life</li>
<li>Stay updated with the latest UI/UX trends, tools, and best practices</li>

  </ul>
</div>
`,

  requirements: (title) => `
<div class="job-requirements">
  <h4>Who Can Apply?</h4>
  <ul>
    <li>Students or recent graduates in Design, Computer Science, or related fields</li>
<li>Basic understanding of UI/UX principles, typography, color theory, and design systems</li>
<li>Proficiency in Figma, Adobe XD, or similar design tools</li>
<li>Ability to think creatively, problem-solve, and work in a fast-paced environment</li>
<li>A strong portfolio showcasing previous UI/UX projects (preferred but not mandatory)</li>

  </ul>
</div>
`,

  qualifications: () => `
<div class="job-qualifications">
  <h4>Growth Opportunities</h4>
  <ul>
    <p>We believe in nurturing talent and providing a structured growth path for every individual who joins us. Here’s how your journey at Avijo can evolve:</p>

<h3>Unpaid Intern (2 Months)</h3>
<p>Ideal for individuals eager to learn and contribute in a flexible, hands-on environment.<br>
Gain real-world experience while working on impactful projects.</p>

<h3>Full-Time Opportunity</h3>
<p>High-performing interns can transition into a full-time role with a competitive salary.<br>
Continue to work on cutting-edge healthcare solutions while growing professionally.</p>

<h3>Top-Level Management / Core Team Members</h3>
<p>Based on performance, leadership skills, and alignment with Avijo’s vision, top contributors can become core team members.<br>
Enjoy benefits such as competitive salaries, company shares, and exclusive perks as a key decision-maker shaping the future of Avijo.</p>

<p>At Avijo, we don’t just offer internships — we create leaders and changemakers in healthcare technology!</p>

  </ul>
</div>
`,

  benefits: (title) => `
<div class="job-benefits">
  <h4>Why Join Avijo?</h4>
  <ul>
    <li>🚀 Work with Founders &amp; Mentors – Get direct guidance from the leadership team.</li>
    <li>🎯 Zero-to-One Journey – Build impactful healthcare solutions from scratch.</li>
    <li>🔍 Larger Decision-Making Power – Influence design decisions in a fast-growing startup.</li>
    <li>🌟 High Growth &amp; Learning – Gain hands-on experience and career acceleration.</li>
    <li>🕒 Flexible Work Environment – Remote/hybrid working options available.</li>
  </ul>

  <h4>How to Apply?</h4>
  <p>Apply here or Send your resume &amp; portfolio to <a href="mailto:careers@avijo.in">careers@avijo.in</a> with the subject: Application for ${title} – [Your Name].</p>

  <p>🚀 Be part of a team shaping the future of healthcare technology!</p>
</div>
`
};

const descriptions = {
  "SEO Intern": {
    aboutRole: _base.aboutRole("SEO Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("SEO Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("SEO Intern")
  },

  "Digital Marketing Intern": {
    aboutRole: _base.aboutRole("Digital Marketing Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Digital Marketing Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Digital Marketing Intern")
  },

  "Business Analyst Intern": {
    aboutRole: _base.aboutRole("Business Analyst Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Business Analyst Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Business Analyst Intern")
  },

  "Marketing Head": {
    aboutRole: _base.aboutRole("Marketing Head"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Marketing Head"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Marketing Head")
  },

  "IT Project Manager": {
    aboutRole: _base.aboutRole("IT Project Manager"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("IT Project Manager"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("IT Project Manager")
  },

  "Video Editor/Creator Intern": {
    aboutRole: _base.aboutRole("Video Editor/Creator Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Video Editor/Creator Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Video Editor/Creator Intern")
  },

  "Graphic Designer Intern": {
    aboutRole: _base.aboutRole("Graphic Designer Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Graphic Designer Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Graphic Designer Intern")
  },

  "Social Media Manager Intern": {
    aboutRole: _base.aboutRole("Social Media Manager Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Social Media Manager Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Social Media Manager Intern")
  },

  "Recruiter/HR Intern": {
    aboutRole: _base.aboutRole("Recruiter/HR Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Recruiter/HR Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Recruiter/HR Intern")
  },

  "Content Creator Intern": {
    aboutRole: _base.aboutRole("Content Creator Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Content Creator Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Content Creator Intern")
  },

  "Finance & Accounts Intern": {
    aboutRole: _base.aboutRole("Finance & Accounts Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Finance & Accounts Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Finance & Accounts Intern")
  },

  "UI/UX Design Intern": {
    aboutRole: _base.aboutRole("UI/UX Design Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("UI/UX Design Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("UI/UX Design Intern")
  },

  "Software Engineer - Intern": {
    aboutRole: _base.aboutRole("Software Engineer - Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Software Engineer - Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Software Engineer - Intern")
  },

  "Chief Technology Officer (CTO)": {
    aboutRole: _base.aboutRole("Chief Technology Officer (CTO)"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("Chief Technology Officer (CTO)"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("Chief Technology Officer (CTO)")
  },

  "React Native Dev - Intern": {
    aboutRole: _base.aboutRole("React Native Dev - Intern"),
    keyResponsibilities: _base.keyResponsibilities(),
    requirements: _base.requirements("React Native Dev - Intern"),
    qualifications: _base.qualifications(),
    benefits: _base.benefits("React Native Dev - Intern")
  }
};

export default descriptions;